/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';

import styles from 'src/shared/app/authentication/component/base/AuthenticationBase.style';

import LoginLinkForm from './LoginLinkForm';
import LoginLinkSuccess from './LoginLinkSuccess';
import messages from 'src/shared/app/authentication/l10n/loginLinkL10n';
import ZIndexTopBar from 'src/shared/app/base/component/template/component/TopBar';
import { loginSupportRoute } from 'src/shared/app/base/route/setting/routeSettings';
import useRoutes from 'src/shared/app/base/route/hook/useRoutes';
import TopBar, {
  backButton,
} from 'src/shared/app/nav/component/top-bar/TopBar';

type Props = {
  isLinkSent: boolean,
};

const useStyles = createUseStyles(styles);

const LoginLinkSectionDumb = ({ isLinkSent }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const intl = useIntl();
  const [loginSupportPath] = useRoutes(loginSupportRoute);

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  const elt = isLinkSent ? <LoginLinkSuccess /> : <LoginLinkForm />;

  return (
    <section className={classes.section}>
      <ZIndexTopBar>
        <TopBar
          title={intl.formatMessage(messages.heading)}
          backTo={loginSupportPath}
          variant={backButton}
        />
      </ZIndexTopBar>
      {elt}
    </section>
  );
};

export default compose(React.memo)(LoginLinkSectionDumb);
